import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconScan = createIcon({
  displayName: 'IconScan',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M5 8H3V3H8V5H5V8ZM8 21H3V16H5V19H8V21ZM16 21H21V16H19V19H16V21ZM21 8H19V5H16V3H21V8ZM11 7H13V17H11V7ZM15 7V17H17V7H15ZM7 7H9V17H7V7Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
